/** Figma `Spinner` 세트(Components, 30:168)의 축 */
export const SPINNER_SIZES = ['sm', 'md', 'lg'] as const;
export type SpinnerSize = (typeof SPINNER_SIZES)[number];

export const SPINNER_TONES = ['primary', 'neutral', 'inverse'] as const;
export type SpinnerTone = (typeof SPINNER_TONES)[number];

/** sm 16(size/icon/sm) · md 24(size/icon/lg) · lg 32(size/icon/xl) — Figma 변수 그대로 */
export const SPINNER_SIZE_CLASS: Record<SpinnerSize, string> = {
  sm: 'size-(--size-icon-sm)',
  md: 'size-(--size-icon-lg)',
  lg: 'size-(--size-icon-xl)',
};

/** 링(track) 색 */
export const SPINNER_TRACK_CLASS: Record<SpinnerTone, string> = {
  primary: 'stroke-bg-muted',
  neutral: 'stroke-bg-muted',
  inverse: 'stroke-fg-muted',
};

/** 도는 호(arc) 색 */
export const SPINNER_ARC_CLASS: Record<SpinnerTone, string> = {
  primary: 'stroke-bg-primary',
  neutral: 'stroke-fg-muted',
  inverse: 'stroke-fg-inverse',
};

/**
 * 모양(viewBox 100 기준). Figma: 가운데가 뚫린 원(innerRadius 0.76) = 두께 12,
 * 호는 12시에서 시계 방향으로 150°(−90° → 60°), 끝이 각지다.
 */
export const SPINNER_GEOMETRY = {
  viewBox: '0 0 100 100',
  center: 50,
  radius: 44,
  strokeWidth: 12,
  pathLength: 360,
  arcDegrees: 150,
} as const;
